document.addEventListener('DOMContentLoaded', function () {

  // --- Parte 1: cargar dropdowns de catálogo (imagen serigrafía, cromo 26, etc.) ---
  // Funciona para cualquier <select data-custom-select="..." data-json-url="..."> que exista en la página.
  var catalogSelects = document.querySelectorAll('[data-custom-select][data-json-url]');

  catalogSelects.forEach(function (select) {
    var jsonUrl = select.dataset.jsonUrl;

    fetch(jsonUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('No se pudo cargar la lista de diseños');
        return res.json();
      })
      .then(function (imagenes) {
        select.innerHTML = '';

        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Selecciona un diseño';
        select.appendChild(placeholder);

        imagenes.forEach(function (nombre) {
          var option = document.createElement('option');
          option.value = nombre;
          option.textContent = nombre;
          select.appendChild(option);
        });
      })
      .catch(function (error) {
        console.error('Error cargando diseños:', error);
        select.innerHTML = '<option value="">No se pudo cargar la lista, recarga la página</option>';
      });
  });

  // --- Parte 2: evitar que el cliente elija el mismo color en Color 1 y Color 2 ---
  // Corre siempre, exista o no el selector de imagen en esta página.
  var color1 = document.querySelector('[data-custom-color="1"]');
  var color2 = document.querySelector('[data-custom-color="2"]');
  var warning = document.querySelector('[data-color-warning]');

  if (color1 && color2) {
    function sincronizarColores() {
      var seleccionado1 = color1.value;

      Array.prototype.forEach.call(color2.options, function (option) {
        if (!option.value) return; // deja el placeholder siempre habilitado
        option.disabled = option.value === seleccionado1;
      });

      // Si Color 2 ya tenía elegido el mismo color que Color 1, lo limpiamos.
      if (color2.value === seleccionado1 && seleccionado1 !== '') {
        color2.value = '';
        if (warning) {
          warning.hidden = false;
          setTimeout(function () { warning.hidden = true; }, 3000);
        }
      }
    }

    color1.addEventListener('change', sincronizarColores);
  }

  // --- Parte 3: bloquear "Agregar al carrito" si faltan campos obligatorios ---
  // Necesario porque el theme usa novalidate: 'novalidate' en el <form>,
  // así que el atributo required de los selects no se valida solo.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var optionsBlock = form.querySelector ? form.querySelector('.custom-product-options') : null;
    if (!optionsBlock) return; // este formulario no tiene nuestros campos, no intervenir

    var camposObligatorios = optionsBlock.querySelectorAll('select[required]');
    var valido = true;
    var primerCampoInvalido = null;

    camposObligatorios.forEach(function (campo) {
      if (!campo.value) {
        valido = false;
        campo.classList.add('custom-product-options__field--error');
        if (!primerCampoInvalido) primerCampoInvalido = campo;
      } else {
        campo.classList.remove('custom-product-options__field--error');
      }
    });

    if (!valido) {
      event.preventDefault();
      event.stopPropagation();

      var mensaje = optionsBlock.querySelector('[data-options-error]');
      if (!mensaje) {
        mensaje = document.createElement('p');
        mensaje.setAttribute('data-options-error', '');
        mensaje.className = 'custom-product-options__error';
        optionsBlock.insertBefore(mensaje, optionsBlock.firstChild);
      }
      mensaje.textContent = 'Selecciona todas las opciones antes de agregar al carrito.';
      mensaje.hidden = false;

      if (primerCampoInvalido) primerCampoInvalido.focus();
    }
  }, true); // "true" = captura el submit ANTES que el JS nativo de Shopify
});
